/**
 * Created by rastwe on 3/14/2017.
 */

/**
 * This file represents the initial state in the Redux store.
 * It's used to provide default values in the reducers, in cases
 * where the store doesn't yet have a value, and there are no
 * action matches in the reducer, so that the return value of
 * the reducer function will never be undefined.
 * Use this file to help give you an idea what the overall
 * picture of the Redux store looks like.
 */

import {delegateTabs, oversightTabs, adminUserTabs} from '../util/uiconstants';

export default {
	accessGroups: [],
	activityLog: {
		lastRefreshed: null,
		data: null,
		page: 1,
		pageSize: 20,
		totalEntityCount: 20,
		column: 'activityDate',
		direction: 'desc',
		exportData: null
	},
	allClients: {
		excludeDelegated: false,
		data: null
	},
	allOtherProjects: [],
	allProjects: [],
	allUserEngagements: {},

	adminUser: [],
	adminUserProject: [],
	adminUserOtherProject: [],
	adminUserClient: [],

	adminUserActiveTab: adminUserTabs.accessibleProjects,
	adminUsers: [],
	apponlinestate: {},
	appVersion: {version: 0.0},

	clientRequest: null,

	configurations: {},
	connectivitystate: {},
	contacts: {
		entities: null,
		orgChart: null,
		customizeColumns: null,
		displayedEntities: null,
		filters: {},
		selected: []
	},
	contactsAccessLog: {
		contactsToAdd: null,
		contactsToRemove: null
	},
	contactDBFilters: {},
	countries: null,
	countryStatus: {},

	engagementMetrics: {},
	engagementUser: {},

	dashboardContext: {
		engagements: [],
		entities: [],
		orgChart: null
	},
	dashboardFilters: {
		milestones: null,
		ccp: null,
		groupAudit: null,
		projectManager: null,
		insight: null,
		reporting: null
	},
	delegate: [],
	delegateActiveTab: delegateTabs.delegateTo,
	documents: [],

	errors: [],
	engagement: {},
	engagementMetaData: null,
	engagementUsersWithRoles: null,
	engagementsSummary: {
		clientEngagements: undefined
	},
	entityAdminsKeyContacts: {},

	filterData: {},

	sessionTimer: {
		timeoutID: null,
		startTime: null,
		showPopup: false,
		startLogout: false
	},
	isEditMode: {
		activated: false,
		redirect: null,
		nodes: null,
		setNodes: null
	},
	isGroupEditMode: false,
	isModalOpen: false,
	isMultiSelectMode: false,
	isRollForwardMode: false,
	isUnsavedUserDataModalOpen: false,

	messageLog: {
		messages: null,
		displayedMessages: null,
		filters: {}
	},

	newProject: {
		Id: '',
		name: '',
		status: '',
		clients: [],
		orgStructure: [],
		type: '',
		engagements: [],
		users: [],
		owners: [],
		engagementCount: 0
	},

	offlinePrep: {},
	orgChart: [],
	oversightActiveTab: oversightTabs.activeProjects,

	reconciliations: {
		lastRefreshed: null,
		data: null,
		selected: {
			componentName: null,
			engagementId: null,
			accounts: null,
			risks: null,
			componentAccounts: null
		}
	},

	roles: [],
	rbacRoles: [],
	paansuserdata: {},
	project: {},
	permissions: {},
	projectEngagementsUsers: [],
	projectTeam: {
		accessGroups: []
	},

	risks: null,

	sample: '',

	timezones: [],

	userPreferences: {isPreferencesLoaded: false},

	quickFilters: {},
	quickLink: [],

	unsavedData: {},
	usersMSData: null,
	userSearchResults: []
};
